import * as React from "react";

import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";

import { Collapse, FormGroup, HTMLSelect } from "@blueprintjs/core";
import { DateInput, IDateFormatProps } from "@blueprintjs/datetime";
import LocalShippingTwoTone from "@material-ui/icons/LocalShippingTwoTone";
import { format, parse } from "date-fns";
import { WithTranslation, withTranslation } from "react-i18next";
import { StyledCard as Card } from "~/layouts/StyledCard";
import styled from "~/styled";
import Topic from "../CustomerSupport/Topic";

interface IProps {
  orderDate: Date;
  withTrackAndTrace: boolean;
  estimate: { lower: Date; upper: Date };
  onOrderDateChange: (orderDate: Date) => void;
  onWithTrackAndTraceChange: (withTrackAndTrace: boolean) => void;
  onToggle: () => void;
  open: boolean;
}

const jsDateFormatter: IDateFormatProps = {
  formatDate: date => format(date, "yyyy-MM-dd"),
  parseDate: str => parse(str, "yyyy-MM-dd", new Date()),
  placeholder: "yyyy-mm-dd"
};

const Form = styled.form`
  margin-top: 24px;
`;

class ETACalculator extends React.Component<IProps & WithTranslation> {
  public render() {
    const { t, orderDate, withTrackAndTrace, estimate, open } = this.props;
    const shippingRate: string = "€1,95";

    return (
      <>
        <a href="#" onClick={this.handleToggle}>
          {t("calculatorCollapse")}
        </a>

        <Collapse isOpen={open}>
          <Card>
            <Topic
              icon={LocalShippingTwoTone}
              title={t("title")}
              description={t("description")}
            />

            <Form method="post" onSubmit={this.handleFormSubmit}>
              <FormGroup
                label={t("inputs.shippingMethod.label")}
                helperText={t("inputs.shippingMethod.description")}
              >
                <HTMLSelect
                  fill={true}
                  value={withTrackAndTrace ? "with" : "without"}
                  onChange={this.handleWithTrackAndTraceChange}
                >
                  <option value="with">
                    {t("inputs.shippingMethod.options.with", {
                      insuredShippingRate: shippingRate
                    })}
                  </option>

                  <option value="without">
                    {t("inputs.shippingMethod.options.without")}
                  </option>
                </HTMLSelect>
              </FormGroup>

              <FormGroup
                label={t("inputs.orderDate.label")}
                helperText={t("inputs.orderDate.description")}
              >
                <DateInput
                  {...jsDateFormatter}
                  onChange={this.handleOrderDateChange}
                  value={orderDate}
                />
              </FormGroup>

              <FormGroup
                label={t("estimateLabel")}
                helperText={
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t("estimateNotReceived")
                    }}
                  />
                }
              >
                <strong>
                  {t("estimate", {
                    lower: format(estimate.lower, "yyyy-MM-dd"),
                    upper: format(estimate.upper, "yyyy-MM-dd")
                  })}
                </strong>
              </FormGroup>
            </Form>
          </Card>
        </Collapse>
      </>
    );
  }

  private handleToggle = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    this.props.onToggle();
  };

  private handleOrderDateChange = (date: Date) => {
    this.props.onOrderDateChange(date);
  };

  private handleWithTrackAndTraceChange = (
    event: React.FormEvent<HTMLSelectElement>
  ) => {
    this.props.onWithTrackAndTraceChange(event.currentTarget.value === "with");
  };

  private handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) =>
    event.preventDefault();
}

export default withTranslation("etaCalculator")(ETACalculator);



// WEBPACK FOOTER //
// ./src/components/ETACalculator/ETACalculator.tsx